export default __webpack_public_path__ + "53ccfc5583ba301a7c641f4e1c3c9c2f.png";